<template>
  <v-autocomplete
    v-model="platformsId"
    :items="platforms"
    item-text="name"
    item-value="id"
    return-object
    :label="label"
    :loading="loading"
    outlined
    :dense="dense"
    :multiple="multiple"
    :disabled="disabled"
    hide-details
    :clearable="clearable"
    :placeholder="placeholder"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar size="32">
        <v-img v-if="item.logos && item.logos.favicon" :src="item.logos.favicon" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.company && item.company.name">
          {{ item.company.name }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center gap-2 mr-4">
        <v-img
          v-if="item.logos && item.logos.favicon"
          :src="item.logos.favicon"
          width="18"
          height="18"
          class="rounded-xl"
        />
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import PLATFORMS from "@/services/admin/platform";

export default {
  props: {
    value: {
      type: [Array, Object],
    },
    label: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      platforms: [],
    };
  },
  methods: {
    async getPlatforms() {
      if (this.items) {
        this.platforms = this.items;
        return;
      }
      try {
        this.loading = true;
        var response = await PLATFORMS.getAll();
        this.platforms = response.platforms.filter(({ active }) => active);
        if (this.selectAll) this.platformsId = [...this.platforms];
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    platformsId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    items: {
      handler(val) {
        if (val) this.platforms = val;
      },
      immediate: true,
    },
    "selectedCompany.id"() {
      if (this.items) return;
      this.platforms = [];
      this.platformsId = [];
      this.getPlatforms();
    },
  },
  mounted() {
    this.getPlatforms();
  },
};
</script>
